import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n";
import { BlitzWareAuthProvider } from "blitzware-react-sdk";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Suspense
    fallback={
      <div className="flex h-screen items-center justify-center">
        Loading...
      </div>
    }
  >
    <BlitzWareAuthProvider
      authParams={{
        clientId: process.env.REACT_APP_BLITZWARE_CLIENT_ID,
        redirectUri: process.env.REACT_APP_BLITZWARE_REDIRECT_URI,
        responseType: "code", // or "token" for implicit flow
      }}
    >
      <App />
    </BlitzWareAuthProvider>
  </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
